import { Section, Carousel } from '../common'

type Props = {
  property: TopHap.ExtendedProperty
  tourUrls?: string[]
}

const Tours: React.FC<Props> = ({ property }) => {
  if (!property.tourUrls?.length) return null

  return (
    <Section
      contentClassName='py-2'
      description={(
        <>
          Take a look inside
          {' '}
          {property.displayAddress}
          .
        </>
      )}
      id='tours'
      mode='Content'
      title='3D & Video Tours'
    >
      <Carousel offset={150}>
        {property.tourUrls.map(url => (
          <li
            key={url}
            className='inline-block w-80 overflow-hidden rounded-xl shadow-md'
          >
            <div className='aspect-h-9 aspect-w-16'>
              <iframe
                allowFullScreen
                className='h-full w-full'
                frameBorder='0'
                src={url}
                title='3D Tour'
              />
            </div>
          </li>
        ))}
      </Carousel>
    </Section>
  )
}

export default Tours
